<template>
  <TableStyleWrapper>
    <TableWrapper class="table-responsive">
      <a-table
        :loading="loadingSubStatusses"
        :dataSource="substatusTableData"
        :columns="substatusTableColumns"
        :pagination="{
          pageSize: tablePageSize,
          showSizeChanger: true,
          total: count,
          current: currentPage,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${count} items`,
        }"
        @change="paginationChange"
      />
    </TableWrapper>
  </TableStyleWrapper>
</template>
<script>
import { TableStyleWrapper } from '../../user/style';
import { TableWrapper } from '../../styled';
import { computed, defineComponent } from 'vue';
import {useStore} from "vuex";
import moment from "moment";
import {useRoute, useRouter} from "vue-router";
import {useAbility} from "@casl/vue";

const substatusTableColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Naam',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Aangemaakt op',
    dataIndex: 'createTimestamp',
    key: 'createTimestamp',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    key: 'action',
    width: '90px',
  },
];
const SubStatusListTable = defineComponent({
  name: 'SubStatusListTable',
  components: { TableStyleWrapper, TableWrapper },
  setup() {
    const { state, dispatch } = useStore();
  const tablePageSize = computed(() => state.substatus.pageSize);
    const substatusses = computed(() => state.substatus.substatusses);
    const loadingSubStatusses = computed(() => state.substatus.loadingSubStatusses);
    const currentPage = computed(() => state.substatus.currentPage);
    const count = computed(() => state.substatus.count);
    const router = useRouter();
    const {matched} = useRoute();
    const {path} = matched[1];
    const { can } = useAbility();
    const handleEdit = (id) => {
      router.push(`${path}/${id}`);
    };
    const substatusTableData = computed(() =>
        substatusses.value.map((substatus) => {
        const { id, name, createTimestamp } = substatus;

        return {
          key: id,
          id: id,
          name: (
            <div class="user-info">

              <figcaption>
                <sdHeading class="user-name" as="h6">
                  {name}
                </sdHeading>
              </figcaption>
            </div>
          ),
          createTimestamp: <span>{moment(createTimestamp).format('DD-MM-YYYY HH:mm:ss')}</span>,
          action: (
              <div className="table-actions">
                {can('view', 'substatus') && name !== 'superadmin' ? (
                    <sdButton onClick={() => handleEdit(id)} className="btn-icon" to="#" type="default" shape="circle">
                      <sdFeatherIcons type="edit" size="16"/>
                    </sdButton>
                ) : ('')}
              </div>
          ),
        };
      }),
    );

    const rowSelection = {
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled substatus', // Column configuration not to be checked
        name: record.name,
      }),
    };

    const paginationChange = async (event) => {
      await dispatch('setCurrentPageSubStatus', event.current);
      await dispatch('getSubStatusses', {page: event.current, pageSize: event.pageSize});
    }

    return {tablePageSize,  substatusTableColumns, substatusTableData, rowSelection,loadingSubStatusses, count, currentPage, paginationChange };
  },
});

export default SubStatusListTable;
</script>
